import React from 'react';

export default ({ width = 32, height = 32, fill = '#FFFFFA' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 512 512'
			preserveAspectRatio='xMidYMid meet'
		>
			<g
				fill={fill}
				stroke={'none'}
				transform={'translate(0,512) scale(0.100000,-0.100000)'}
			>
				<path d='M2325 5104 c-321 -49 -599 -196 -836 -441 -230 -238 -357 -487 -405 -798 -11 -70 -14 -226 -14 -697 l0 -608 -84 0 c-63 0 -101 -6 -143 -22 -77 -29 -152 -104 -181 -181 -22 -58 -22 -58 -22 -1077 0 -1019 0 -1019 22 -1077 29 -77 104 -152 181 -181 l58 -22 1659 0 1659 0 58 22 c77 29 152 104 181 181 22 58 22 58 22 1077 0 1019 0 1019 -22 1077 -29 77 -104 152 -181 181 -42 16 -80 22 -143 22 l-84 0 0 608 c0 471 -3 627 -14 697 -48 311 -175 560 -405 798-298 308 -658 460 -1084 456 -73 -1 -172 -7 -222 -15z m453 -655 c283 -72 515 -299 604 -591 22 -72 22 -85 26 -685 l3 -613 -851 0 -851 0 3 613 c4 600 4 613 26 685 85 278 302 501 568 581 145 45 323 48 472 10z' />
			</g>
		</svg>
	);
};
